import script from "./esTabsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./esTabsModal.vue?vue&type=script&setup=true&lang=ts"

import "./esTabsModal.vue?vue&type=style&index=0&id=7478d856&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7478d856"]])

export default __exports__